// src/components/claims/OnlineClaimView.js
import React, { useEffect, useState } from 'react';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  Grid,
  Backdrop,
  CircularProgress,
  AppBar,
  Container
} from '@material-ui/core';
import { useParams, useLocation } from 'react-router-dom';
import { useClaimsContext } from '../../context/claims_context';
import Controls from '../controls/Controls';
import ClaimSubform from './ClaimSubform';
import ClaimsAdjud from './ClaimsAdjud';
import { ClaimDocuments } from '../reports/claims/ClaimDocuments';
import ClaimsApproval from './ClaimsAppoval';
import { baseUrl } from '../../utils/constants'; // only needed if you use the optional fetch below

export default function OnlineClaimView() {
  // If you want to hydrate claimNo using the URL or navigation state, keep these:
  const { id } = useParams();
  const location = useLocation();

  // Context: we expect claimNo to be available (from prior navigation / state)
  const { claimNo, setClaimNo } = useClaimsContext();

  const tenant = sessionStorage.getItem('userRefId');
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const onTabClicked = (_event, newIndex) => setIndex(newIndex);
  const Panel = (props) => <div hidden={props.value !== props.index}>{props.children}</div>;
  const handleLoadingClose = () => setLoading(false);
  const notifyPopup = (message, type) =>
    setNotify({ isOpen: true, message: `${message}`, type: `${type}` });

  /**
   * OPTIONAL: Hydrate claimNo when landing directly on /claims/online/:id.
   * If your list view already calls setClaimNo before navigating, you can delete this block.
   */
  useEffect(() => {
    // Prefer claim_ID from navigation state if present
    const stateRow = location?.state?.row;
    const stateClaimId = stateRow?.claim_ID;
    const routeId = Number(id);

    if (!claimNo) {
      if (Number.isFinite(stateClaimId)) {
        setClaimNo(stateClaimId);
      } else if (Number.isFinite(routeId)) {
        // If you need to validate that this claim exists, you can do a lightweight check:
        // setLoading(true);
        // fetch(`${baseUrl}/api/claims/getClaimById?claimId=${routeId}`)
        //   .then((r) => r.json())
        //   .then((res) => {
        //     if (res?.result?.claim_ID) setClaimNo(res.result.claim_ID);
        //     else notifyPopup('Claim not found.', 'error');
        //   })
        //   .catch((err) => notifyPopup(`Error loading claim: ${err}`, 'error'))
        //   .finally(() => setLoading(false));
        setClaimNo(routeId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, location.state]);

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Grid margin={2} container spacing={2} direction="row">
        <Grid item xs={3} sm={3} mr={2}>
          <Typography component="span" variant="h6" gutterBottom>
            Processed Claim
          </Typography>
        </Grid>
      </Grid>

      <Card>
        <CardContent>
          <AppBar position="static" color="darkblack">
            <Tabs
              value={index}
              indicatorColor="primary"
              onChange={onTabClicked}
              aria-label="claims-process-tabs"
            >
              <Tab label="Claim Detail" />
              <Tab label="Services Claimed" />
              <Tab label="Documents" />
              {Number(tenant) < 30 && <Tab label="Approvals" />}
            </Tabs>
          </AppBar>

          <Box> </Box>

          {/* Claim Detail */}
          <Panel value={index} index={0}>
            <ClaimsAdjud />
          </Panel>

          {/* Services Claimed */}
          <Panel value={index} index={1}>
            <ClaimSubform />
          </Panel>

          {/* Documents */}
          <Panel value={index} index={2}>
            <ClaimDocuments refId={claimNo} />
          </Panel>

          {/* Approvals (conditional by tenant) */}
          {Number(tenant) < 30 && (
            <Panel value={index} index={3}>
              <ClaimsApproval />
            </Panel>
          )}
        </CardContent>

        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Card>
    </Container>
  );
}
